import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'afs-gamble-warning-bar',
  styleUrl: 'afs-gamble-warning-bar.sass',
  shadow: true,
})
export class AfsGambleWarningBar {

  @Prop() license : string = "XXXXXX";

  render() {
    return (
      <div class="gamble-policy-wrapper">
          <div class="chances-wrapper gp__top">
              <span>Actual odds depend on the number of tickets sold.</span>
          </div>
          <div class="license-wrapper gp__top">
              <span>BC Gaming Event Licence #{this.license}</span>
          </div>
          <div class="help-wrapper gp__bottom">
              <span>Problem Gambling Help Line 1-888-795-6111</span>
          </div>
          <div class="website-wrapper gp__bottom">
              <span><a href="https://www.bcresponsiblegambling.ca" target="_blank">www.bcresponsiblegambling.ca</a></span>
          </div>
          <div class="warning-wrapper gp__bottom">
              <span>Know your limit, play within it</span>
          </div>
          <div class="age-wrapper gp__bottom">
              <span>19+</span>
          </div>
      </div>
    );
  }

}
